import React from 'react';
import './ProblemSolution.css';

const ProblemSolution: React.FC = () => {
  return (
    <section className="problem-solution">
      <div className="container">
        <div className="section-header">
          <div className="section-label">The Challenge</div>
          <h2 className="section-title">Traditional Credit Models Are Flat. The World Is Not.</h2>
          <p className="section-subtitle">Credit scoring systems haven't evolved to match the complexity of modern financial networks.</p>
        </div>
        
        <div className="problem-cards">
          <div className="card">
            <div className="card-inner">
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 20H22V22H2V20ZM4 12H6V19H4V12ZM9 12H11V19H9V12ZM13 12H15V19H13V12ZM18 12H20V19H18V12ZM2 7L12 2L22 7V11H2V7ZM4 8.236V9H20V8.236L12 4.236L4 8.236ZM12 8C11.448 8 11 7.552 11 7C11 6.448 11.448 6 12 6C12.552 6 13 6.448 13 7C13 7.552 12.552 8 12 8Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Legacy Scores Miss Hidden Risks</h3>
              <p>Traditional models fail to capture complex relationships between businesses, suppliers, and networks, missing critical risk signals.</p>
            </div>
            <div className="card-hover"></div>
          </div>
          
          <div className="card">
            <div className="card-inner">
              <div className="card-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.071 4.929C16.966 2.824 14.071 1.5 11 1.5C7.929 1.5 5.034 2.824 2.929 4.929C0.824 7.034 -0.5 9.929 -0.5 13C-0.5 16.071 0.824 18.966 2.929 21.071C5.034 23.176 7.929 24.5 11 24.5C14.071 24.5 16.966 23.176 19.071 21.071C21.176 18.966 22.5 16.071 22.5 13C22.5 9.929 21.176 7.034 19.071 4.929ZM11 22.5C5.763 22.5 1.5 18.237 1.5 13C1.5 7.763 5.763 3.5 11 3.5C16.237 3.5 20.5 7.763 20.5 13C20.5 18.237 16.237 22.5 11 22.5ZM16 12H12V8C12 7.447 11.553 7 11 7C10.447 7 10 7.447 10 8V13C10 13.553 10.447 14 11 14H16C16.553 14 17 13.553 17 13C17 12.447 16.553 12 16 12Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Complex SME Networks</h3>
              <p>Small and medium enterprises operate within complex networks that remain invisible to traditional credit systems.</p>
            </div>
            <div className="card-hover"></div>
          </div>
          
        </div>
        
        <div className="solution-container">
          <div className="solution-highlight"></div>
          <p className="solution-subtitle">Our platform brings transparency, structure, and modern graph analytics to risk assessment, revealing hidden connections and providing deeper insights.</p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;